import mutation_types from "./mutation_types.js";
import Vue from 'vue';

export default {
    [mutation_types.SET_TRANSFER_LISTS](state, data) {
        Object.assign(state.transferLists, data);
    },
    [mutation_types.CLEAR_TRANSFER_LISTS](state) {
        state.transferLists = {};
    }
}
